import { render } from "./ProductSalesPerSkuSkeleton.vue?vue&type=template&id=709a931e&scoped=true"
import script from "./ProductSalesPerSkuSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductSalesPerSkuSkeleton.vue?vue&type=script&lang=js"

import "./ProductSalesPerSkuSkeleton.vue?vue&type=style&index=0&id=709a931e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709a931e"]])

export default __exports__